// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userMenu .el-menu-item[data-v-4c7e73ff],\n.userMenu .el-submenu__title[data-v-4c7e73ff] {\n  height: 40px;\n  line-height: 40px;\n}", ""]);
// Exports
module.exports = exports;
